document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  $(document).on('quickbuy:loaded', function ($quickbuyCont) {
    if (!window.mz || !window.mz.track) {
      return
    }
    Array.from(
      document.querySelectorAll('.form.product-purchase-form .button.button--large')
    ).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.form;
        if (!form) { return; }
        var uid = form.getAttribute('data-product-id')
        if (uid) {
          window.mz.track('add2cart', { uid: uid })
        }
      })
    })
  })

  function afterUpdate() {
    if (mz.app.filterLayout !== 'vertical' || mz.app.hits.total === 0) {
      $('.filter-container--side .filters').addClass('mz-hidden')
    } else {
      $('.filter-container--side .filters').removeClass('mz-hidden')
    }
    theme.ProductBlockManager.unloadImages('.mz-hits')
    theme.ProductBlockManager.loadImages('.mz-hits')

    $('.show-search .main-search__close.button').click()
    $('.expanded .quickbuy-container .close-detail').click()
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})

// filter visibility
toggleFilter = function() {
  var aggs = document.querySelector('.mz-results');
  if (!aggs) {
    return;
  }   
  if(aggs.classList.contains('mz-collapsed-filter')) {
    aggs.classList.remove('mz-collapsed-filter');
  } else {
    aggs.classList.add('mz-collapsed-filter');
  }
  // handle resized collection grid
  theme.ProductBlockManager.afterImagesResized();
  return false;
};

